import { configTypes } from '@/models/featureConfig'
import { documentId } from '@/modules/auth/index-firebase'
import DatabaseFactory from '@/wrappers/database'
import { addErrorLog } from '@/wrappers/database/utils/addLog'

const getFeatureFlagById = async (
  store,
  { id, type = configTypes.BOOLEAN, flagUserId }
) => {
  if (!id) return
  const database = new DatabaseFactory(
    `feature_configs/${id}`
  ).getReadDatabase()
  try {
    const doc = await database.getOne(id)

    const data = doc?.data()
    store.commit('updateFeatureConfig', data)

    if (type === configTypes.BOOLEAN || type === configTypes.STRING) {
      return store.getters.getValue(id)
    }
    const userId = flagUserId || store.rootState.user.user.id
    return store.getters.isVisibleByUserId({ name: id, userId })
  } catch (error) {
    addErrorLog({
      context: 'featureConfig/actions - fetchById',
      error
    })
  }
}

const fetchRealtime = (store, { name, notification }) => {
  if (!notification) {
    /* eslint-disable no-console */
    console.warn(
      'You must provide a notification to inform the user that the application behavior changed.'
    )
    return
  }

  const { listener: configListener } = store.state
  if (configListener) configListener()

  const configNames = [...store.state.notifications.map(c => c.name), name]

  if (configNames.length > 10) {
    /* eslint-disable no-console */
    console.warn(
      'It is not possible to have more than 10 realtime feature configs.'
    )
    return
  }
  const database = new DatabaseFactory('feature_configs').getReadDatabase()
  const query = {
    filters: [
      {
        field: documentId(),
        condition: 'in',
        value: configNames
      }
    ]
  }
  const listener = database.getStream(
    query,
    snapshot => {
      snapshot.docs.forEach(doc => {
        const config = doc.data()
        const notification = store.getters.getNotification(config)

        store.commit('updateFeatureConfig', config)

        if (notification) {
          store.commit('errors/setError', notification, {
            root: true
          })
        }
      })
    },
    error =>
      addErrorLog({
        context: 'featureConfig/actions - fetchRealtime',
        error
      })
  )

  store.commit('setListener', listener)
  store.commit('setNotification', { name, message: notification })
}

export default {
  fetchRealtime,
  getFeatureFlagById
}
